module.exports = __webpack_public_path__ + "img/symbol_stargreen.673cc5d1.png";